import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { trackEventLog } from '../../../core/utils'

import s from './index.css';
import LOGO from './logo.png'
import JPK from './ic_JPK.png'
import FYG from './ic_Fyg.png'
import CD from './ic_CD.png'
import SECD from './ic_SECD.png'
import YDKY from './ic_YDKY.png'
import YDLD from './ic_YDLD.png'
import YDKD from './ic_YDKD.png'
import XTL from './ic_XTL.png'
import SEYY from './ic_SEYY.jpg'
import WB from './weibo.png'
import WC from './wechat.png'
import { QUALIFICATION } from '../../../constants'

const NEW_GUIDE = [
  {
    name: '课程说明',
    url: 'https://c.youdao.com/article/index.html?pid=19188',
  },
  {
    name: '如何使用',
    url: 'https://c.youdao.com/article/index.html?pid=19186',
  },
  {
    name: '常见问题',
    url: 'https://c.youdao.com/article/index.html?pid=18504',
  },
]
const STUDY_TOOLS = [
  {
    name: '有道<br>精品课',
    img: JPK,
    url: 'http://app.xue.youdao.com/?keyfrom=xuetang',
  },
  {
    name: '有道<br>翻译官',
    img: FYG,
    url: 'https://fanyiguan.youdao.com/?keyfrom=xuetang',
  },
  {
    name: '有道<br>词典',
    img: CD,
    url: 'https://dict.youdao.com/?keyfrom=xuetang',
  },
  {
    name: '有道<br>少儿词典',
    img: SECD,
    url: 'https://kiddict.youdao.com?vendor=jpkguanwang',
  },
  {
    name: '有道<br>口语',
    img: YDKY,
    url: 'https://speak.youdao.com/?vendor=jpkguanwang',
  },
  {
    name: '有道<br>乐读',
    img: YDLD,
    url: 'https://m.du.youdao.com/download?vendor=jpkguanwang',
  },
  {
    name: '有道<br>卡搭',
    img: YDKD,
    url: 'https://geek.163.com/?share=3&shareId=480000005564616',
  },
  {
    name: '有道<br>小图灵',
    img: XTL,
    url: 'https://c.youdao.com/icode/download.html',
  },
  {
    name: '有道<br>少儿英语',
    img: SEYY,
    url: 'https://kids.youdao.com/',
  },
]
const FRIEND_LINKS = [
  {
    name: '网易云课堂',
    url: 'http://study.163.com/',
  },
  {
    name: '网易公开课',
    url: 'https://open.163.com/',
  },
  {
    name: '网易云音乐',
    url: 'http://music.163.com/',
  },
  {
    name: '有道词典',
    url: 'http://dict.youdao.com/',
  },
  {
    name: '有道云笔记',
    url: 'http://note.youdao.com/',
  },
  {
    name: '有道背单词',
    url: 'http://recite.youdao.com/',
  },
  {
    name: '有道卡搭',
    url: 'https://geek.163.com/?share=3&shareId=480000005564616',
  },
  {
    name: '有道智选',
    url: 'http://dsp.youdao.com/',
  },
  {
    name: '有道人工翻译',
    url: 'http://f.youdao.com/',
  },
  {
    name: '有道翻译官',
    url: 'http://fanyiguan.youdao.com/',
  },
  {
    name: '网易严选',
    url: 'https://you.163.com/',
  },
  {
    name: '网易邮箱',
    url: 'http://mail.163.com/',
  },
]
const ABOUT = [
  {
    name: '官方博客',
    url: 'http://i.youdao.com',
  },
  {
    name: '技术博客',
    url: 'http://techblog.youdao.com/',
  },
  {
    name: '诚聘英才',
    url: 'https://hr.163.com',
  },
]
const renderLinks = data => data.map((link, inx) => <a key={`ft-link-${inx}`} href={link.url} target="_blank" rel="noopener noreferrer">{link.name}</a>)
const renderStudyTools = () => STUDY_TOOLS.map((tool, inx) => <a key={`ft-tool-${inx}`} href={tool.url} target="_blank" rel="noopener noreferrer" onClick={() => { trackEventLog(`webToolClick_${inx}`) }}><img src={tool.img} alt="学习工具" /><span dangerouslySetInnerHTML={{ __html: tool.name }} /></a>)

class Footer extends React.Component {

  constructor(props) {
    super(props)
    this.toastTimeout = null
  }

  render() {
    const { footStyle } = this.props
    return (
      <div className={s.root} style={footStyle}>
        <div className={s.border} />
        <div className={s.inner}>
          <div className={s.topPart}>
            <div className={s.logo}>
              <img src={LOGO} alt="有道精品课" />
              {/* eslint-disable*/}
              <a href="http://c.youdao.com/market/best/bestPc/index.html" target="_blank" rel="noopener noreferrer">同道计划</a>
            </div>
            <div className={s.newGuide}>
              <h4>新手指南</h4>
              {renderLinks(NEW_GUIDE)}
            </div>
            <div className={s.contactUs}>
              <h4>联系我们</h4>
              <p>客服：400 867 1360</p>
              <p>周一至周日 9:00-24:00（春节除外）</p>
              <p>邮箱：youdao_kecheng@163.com</p>
            </div>
            <div className={s.studyTools}>
              <h4>学习工具</h4>
              {renderStudyTools()}
            </div>
          </div>
          <div className={s.bottomPart}>
            <div className={s.friendLinks}>友情链接：{renderLinks(FRIEND_LINKS)}</div>
            <div className={s.qualityAndAbout}>
              <span className={s.quality}>
                ©{new Date().getFullYear()} {renderLinks(QUALIFICATION)} 京ICP证080268号 京公网安备 11010802020092号
              </span>
              <span className={s.about}>
                {renderLinks(ABOUT)}
                <a href="http://weibo.com/u/5262241784" target="_blank" rel="noopener noreferrer"><img src={WB} alt="微博" /></a>
                <div className={s.weixin}>
                  <img src={WC} alt="公众号" />
                  <div className={s.pop}>
                    <img src="https://oimagea1.ydstatic.com/image?id=1871096814275540735&product=xue" alt="扫码关注有道精品课"/>
                    <p>扫码关注有道精品课</p>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
Footer.propTypes = {
  footStyle: PropTypes.object,
}

export default withStyles(s)(Footer)





// WEBPACK FOOTER //
// ./src/components/global/Footer/index.js